var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.showModal)?_c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal-background",on:{"click":_vm.toggleModal}}),_vm._v(" "),_c('div',{staticClass:"modal-content",style:({ maxWidth: _vm.maxWidth + 'px' })},[_vm._t("default")],2)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b23c7fe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/Modal.vue
// module id = null
// module chunks = 